import i18next from "i18next"
import { initReactI18next } from "react-i18next"

import englishTranslations from "./locales/en.json"
import filipinoTranslations from "./locales/fil.json"

export const LANGUAGE_STORAGE_KEY = "language"

export const languages = ["en", "fil"]

const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY)
const initialLanguage =
  storedLanguage && languages.includes(storedLanguage)
    ? storedLanguage
    : undefined

// pass the i18next instance to react-i18next.
// eslint-disable-next-line import/no-named-as-default-member
const i18n = i18next.use(initReactI18next)

// init i18next - for all options read: https://www.i18next.com/overview/configuration-options
void i18n.init({
  lng: initialLanguage,
  debug: import.meta.env.MODE !== "test" && !import.meta.env.PROD,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    en: { translation: englishTranslations },
    fil: { translation: filipinoTranslations },
  },
})

export default i18n
